/**
 * The toolbar's set height. MUI's min-height wins where it is taller: 56px
 * on phones, 64px from sm up.
 */
export const APP_BAR_TOOLBAR_HEIGHT = '3.5rem'

/** The top bar's height as rendered, for what sits just below it. */
export const APP_BAR_HEIGHT = {
  xs: `max(56px, ${APP_BAR_TOOLBAR_HEIGHT})`,
  sm: `max(64px, ${APP_BAR_TOOLBAR_HEIGHT})`,
}

/**
 * The toolbar's spacing with Ask Attorney Share's circle in it: tighter on
 * phones, and between md and lg, where the nav links leave little to spare.
 * Without the circle the bar keeps a gap of 4.
 */
export const APP_BAR_GAP_WITH_ASSISTANT = { xs: 1, md: 2, lg: 4 }

/** The gap before the user menu: tighter on phones, beside the circle. */
export const APP_BAR_USER_MENU_GAP = { xs: 0.5, sm: 1 }

/** Below MUI's appBar level (1100), as it always was. */
export const APP_BAR_Z_INDEX = 1000

/** The mobile bottom nav's height (px): its buttons' min-height (Links.tsx). */
export const MOBILE_BOTTOM_NAV_HEIGHT = 64
